import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TypeUtilService } from '@src/app/core/services/utils/type-util.service';
import { IProductCommandContext } from '@src/app/shared/models/command';
import { ProductTypes } from '@src/app/shared/models/products.model';

import { LoadingService } from '@core/services/loading/loading.service';
import { PrintDocumentService } from '@core/services/print/print-document.service';
import { FileUtilService } from '@core/services/utils/file-util.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationOfOpeningAccountCommand extends BaseProductCommand {
  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private printDocumentService: PrintDocumentService,
    private fileUtilService: FileUtilService,
    private loadingService: LoadingService
  ) {
    super(commandAvailabilityService);
  }
  type: string = 'applicationOnOpeningAccount';
  title: string = 'Заявление на открытие счета';
  icon: string = 'blank-white';
  productType: ProductTypes | ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.METAL_ACCOUNT,
    ProductTypes.SAVE_ACCOUNT
  ];
  isInfoAction: boolean = false;
  settingsNames?: string[];
  order?: number = 999;

  async execute(context: IProductCommandContext): Promise<void> {
    this.loadingService.showLoader(true);
    this.printDocumentService.getPrintAccDocument(context.data.contractId).subscribe(
      async (res) => {
        const docName = 'application_of_opening_account.pdf';
        this.loadingService.showLoader(false);
        await this.fileUtilService.extractAttachment(res, docName, 'application/pdf');
      },
      (error) => {
        this.loadingService.showLoader(false);
        console.log('Документ недоступен');
      }
    );
  }

  protected checkAdditionalAvailability(_context: IProductCommandContext): Observable<boolean> | boolean | undefined {
    return TypeUtilService.isTruthy(_context.data.isOpenDBO);
  }
}
